/**
 * Main.js
 *
 * @since 1.0.0
 */

import "whatwg-fetch";
import 'objectFitPolyfill';
import objectFitImages from 'object-fit-images';
import LazyLoadFonts from "./modules/LazyLoadFonts";
import Raven from "raven-js";
import FormValidation from "./modules/FormValidation";
import Animation from "./modules/Animation";
import LazyLoadBackground from "./modules/LazyLoadBackground";
import ScrollDown from "./modules/ScrollDown";
import Slider from "./modules/Slider";
import PageHeader from "./modules/PageHeader";
import Counter from "./modules/Counter";
import SendForm from "./modules/SendForm";
import ScrollTo from "./modules/ScrollTo";
import MasonryGrid from "./modules/MasonryGrid";
import Overlay from "./modules/Overlay";
import Modal from "./modules/Modal";
import ProductFeatures from "./modules/ProductFeatures";
import LanguageSwitcher from "./modules/LanguageSwitcher";
import SwipeSlider from "./modules/SwipeSlider";
import Toggle from "./modules/Toggle";
import BrochurePopup from "./modules/BrochurePopup";
import CarePopup from "./modules/CarePopup";
import DependsValue from "./modules/DependsValue";

(function IIFE() {
  // if (process.env.NODE_ENV === "production") {
  //   Raven.config(
  //     "https://8a0a084746764fc689889da26b61ebb3@sentry.io/165250"
  //   ).install();
  // }
  objectFitImages();
  LazyLoadFonts();
  FormValidation();
  Animation();
  LazyLoadBackground();
  ScrollDown();
  Slider();
  PageHeader();
  Counter();
  SendForm();
  ScrollTo();
  MasonryGrid();
  Overlay();
  Modal();
  ProductFeatures();
  LanguageSwitcher();
  SwipeSlider();
  Toggle();
  BrochurePopup();
  CarePopup();
  DependsValue();
})();



// WEBPACK FOOTER //
// ./src/js/main.js